"use client";

import { useSyncExternalStore } from "react";

const COARSE = "(pointer: coarse)";
const NARROW = "(max-width: 767px)";

function subscribe(onChange: () => void) {
  const a = window.matchMedia(COARSE);
  const b = window.matchMedia(NARROW);
  a.addEventListener("change", onChange);
  b.addEventListener("change", onChange);
  return () => {
    a.removeEventListener("change", onChange);
    b.removeEventListener("change", onChange);
  };
}

function getSnapshot() {
  return window.matchMedia(COARSE).matches || window.matchMedia(NARROW).matches;
}

/**
 * True on coarse-pointer OR narrow (<768px) viewports — the shared "lite mobile"
 * gate for dropping heavy ambient / scroll-coupled work on phones.
 *
 * SSR-safe by construction: getServerSnapshot() => false (mirrors
 * useReducedMotionPref in use-signal-progress.ts), so the server and the first
 * client paint render the FULL desktop tree — identical hydration contract — and
 * the client only commits to `true` on phones, reacting live to orientation /
 * resize. Call it UNCONDITIONALLY at the top of a component, then gate WORK, not
 * the hook: conditional MOUNT in the parent (`{!lite && <X/>}`), a constant
 * MotionValue swap so a spring frameloop idles, or `if (lite) return;` inside an
 * effect / frame-callback body.
 */
export function useCoarseOrNarrow(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
